import { Button } from 'component/Button'
import { Img } from 'component/Image'
import { Gap, Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { SaveButtonPane } from 'page/ProfileScreen/SaveButton/SaveButtonPane'
import { opt } from 'store/opt'
import { store } from 'store/store'
import css from './ProfileStep.module.scss'

export const ProfileStep = observer(() => {
  const { selfies, userPhoto } = store.profile.common
  const edit = !!store.profile.identity_id
  const data_management = false

  const onEdit = useLatestCallback(() => {
    store.profile.common.reset()
    store.profile.simple.stage = 'selfie'
  })

  const onData = useLatestCallback(() => {
    store.profile.step = 'data'
  })

  return (
    <Vertical wide tall maxWidth="var(--max-width)">
      <Space spring wide oh>
        <Img className={css.full} src={userPhoto.src} />
        <Img className={css.face} src={selfies[0].src} />
      </Space>
      <Gap height={32} />
      <Button wide large flat action={onEdit}>
        {i18n('EditProfile')}
      </Button>
      {edit && <>
        <Gap height={12} />
        <SaveButtonPane />
        {data_management && (
          <Button link={!opt.tsum} large={opt.tsum} action={onData}>
            {i18n('UserDataManagement')}
          </Button>
        )}
      </>}
    </Vertical>
  )
})
